<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <input class="search" type="text" [(ngModel)]="search" placeholder="Search files" autocomplete="off" />
            <button class="add-btn" type="button" (click)="openFileModal()">Add file</button>
        </div>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else if (files.length === 0) {
            <p class="state-text">No files yet.</p>
        } @else if (filteredFiles.length === 0) {
            <p class="state-text">No files match your search.</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>Filename</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (f of filteredFiles; track f.id) {
                            <tr>
                                <td>{{ f.title }}</td>
                                <td class="descr">{{ f.descr }}</td>
                                <td class="category">
                                    @if (f.categoryName) {
                                        <span class="chip">{{ f.categoryName }}</span>
                                    } @else {
                                        <span class="muted">—</span>
                                    }
                                </td>
                                <td class="filename">{{ f.realFilename }}</td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn download" (click)="download(f)"
                                        ngbTooltip="Download" container="body">
                                        <fa-icon [icon]="faDownload"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn" (click)="openFileModal(f)"
                                        ngbTooltip="Edit" container="body">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(f)"
                                        ngbTooltip="Delete" container="body">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
